module.exports = __webpack_public_path__ + "img/26.4d4ae88e.png";